import React from 'react';
import './LaunchFooter.css';
import GeneralButton from './GeneralButton';

const LaunchFooter = (props: any) => {
	return (
		<div className="launch-footer bottom-shadow-background launch-footer-background modal-disable-select">
			<div className="launch-footer-front">
				<GeneralButton onClick={props.onClick} text="LAUNCH SCENARIO" style={{top:'12px'}}/>
				<div tabIndex={0} className="bottom-description">{props.description}</div>
			</div>
		</div>
	);
};

export default LaunchFooter;
